<template>
  <div class="toast">
    <span class="text-sm">Would you like to add stethoscope to the session?</span>
    <button @click="handleStethoscopeConnection(true)" class="act text-vice-teal-400">
      ACCEPT
    </button>
    <button @click="handleStethoscopeConnection(false)" class="act text-red-600">DENY</button>
    <button @click="closeToast">
      <CrossSimpleIcon type="link"></CrossSimpleIcon>
    </button>
  </div>
</template>

<script>
import CrossSimpleIcon from '@/Components/Icons/CrossSimpleIcon.vue';

export default {
  components: { CrossSimpleIcon },
  emits: ['stethoscopeConnectionAllowed', 'toggleToast'],
  props: {
    showToast: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const handleStethoscopeConnection = (accepted) => {
      emit('stethoscopeConnectionAllowed', !!accepted);
    };

    const closeToast = () => {
      emit('toggleToast');
    };

    return { handleStethoscopeConnection, closeToast };
  },
};
</script>

<style scoped>
.toast {
  position: fixed;
  right: 22rem;
  z-index: 999;
  top: 8rem;
  min-width: 200px;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  color: white;
  display: flex;
  align-items: center;
  background-color: #656262;
}

button {
  border: none;
  padding: 3px;
}

.act {
  margin-left: 10px;
}
</style>
